export default {"src":"https://cdn.tanzhi.cn/_next/static/media/clan.b9caf7d8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};